import Api from './api.service'

export default {
  getNotifications (filter) {
    return Api().get('notification/get', { params: filter })
  },
  markAsDeleted (notificationIds) {
    return Api().put('notification/markAsDeleted', { notificationIds })
  },
  markAsEmailSent (notificationIds) {
    return Api().put('notification/markAsEmailSent', { notificationIds })
  },
  checkTodayEmailSent () {
    return Api().get('notification/checkTodayEmailSent')
  }
}
